import React, { useEffect } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "./components/Header";
// import ReactGA from "react-ga";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TextGenerator from "./pages/TextGenerator";
import Login from "./pages/login/index";
import Register from "./pages/register/index";
import Profile from "./pages/profile/index";
import { userLoggedIn } from "./redux/actions/user.action";

const App = () => {
  const user = useSelector((state) => state.user);
  const isLoggedin = user.isLoggedin;
  const dispatch = useDispatch();

  useEffect(() => {
    const getUser = localStorage.getItem("hashUser");
    if (getUser) {
      dispatch(userLoggedIn(JSON.parse(getUser)));
    }
  }, []);

  // ReactGA.initialize("G-0FVJ1BK4WX");
  // useEffect(() => {
  //   ReactGA.pageview(window.location.pathname + window.location.search);
  // });
  return (
    <div className="App">
      <Header />
      <Switch>
        <Route path="/" exact={true} component={Home} />
        <Route path="/profile" exact={true} component={Profile} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/text-generator" component={TextGenerator} />
        {!isLoggedin && <Route path="/login" component={Login} />}
        {!isLoggedin && <Route path="/register" component={Register} />}
        <Route component={() => <Redirect to={"/"} />} />
      </Switch>
      <div className="product_hunt_batch">
        <a
          href="https://www.producthunt.com/posts/hashfinder?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-hashfinder"
          target="_blank"
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=318883&theme=dark"
            alt="Hashfinder - A search engine for the social web | Product Hunt"
            style={{ width: 250, height: 54 }}
            width={250}
            height={54}
          />
        </a>
      </div>
    </div>
  );
};

export default withRouter(App);
